/**
 * Locale-aware month / weekday names via `Intl.DateTimeFormat`.
 *
 * Extracted verbatim from `date_picker.tsx` so the calendar grid can share
 * them. Index conventions match the picker: month index 0 = January, weekday
 * index 0 = Sunday. The probe dates are built in LOCAL time on purpose —
 * 2000-01-01 is January and 2000-01-02 is a Sunday in every timezone, and
 * local construction is what the picker always did, so its output is
 * byte-identical.
 */

/** Month names, index 0 = January … 11 = December. */
export function get_month_names(
  locale: string,
  format: 'long' | 'short',
): readonly string[] {
  const formatter = new Intl.DateTimeFormat(locale, { month: format });
  return Array.from({ length: 12 }, (_, i) =>
    formatter.format(new Date(2000, i, 1)),
  );
}

/** Weekday names, index 0 = Sunday … 6 = Saturday. */
export function get_weekday_names(
  locale: string,
  format: 'narrow' | 'short' | 'long',
): readonly string[] {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: format });
  // 2000-01-02 is a Sunday; pick 7 consecutive days.
  return Array.from({ length: 7 }, (_, i) =>
    formatter.format(new Date(2000, 0, 2 + i)),
  );
}
